<template>
  <fieldset>
    <legend hidden>Preencha este campo</legend>
    <div class="mdn-Input"
      v-bind:class="{ 'mdn-isInitialized mdn-Input--attentionField': !valid, 'mdn-Input--activatedField': !!value }"
    >
      <input
        @input="setValue"
        @blur="onBlur()"
        :value="value"
        :maxlength="Number(maxlength)"
        :name="name"
        :id="name"
        class="mdn-Input-field"
        :type="type"
        required
        :disabled="disabled"
      />

      <img class="mdn-Input-action w-8" style="transform: translate(-50%, -50%);" v-if="!!externalIcon" :src="externalIcon"/>
      <span v-else-if="!!internalIcon" class="text-red-500 mdn-Icon--md" :class="[internalIcon]"></span>
      <label
        :for=name
        class="mdn-Input-label mdn-Input--activatedField label"
      >
        {{placeholder}}
      </label>
      <small
        class="mdn-Input-errorFeedback"
        v-bind:class="{ 'block': !valid }"
        >{{errorMessage}}</small>
    </div>
  </fieldset>
</template>

<script>
import { maskJs } from 'mask-js'

export default {
  name: 'MdnInput',
  data () {
    return {
      value: undefined,
      touched: false,
      valid: true,
      errorMessage: '',
      inputName: this.name
    }
  },
  props: {
    name: String,
    placeholder: String,
    type: String,
    required: Boolean,
    disabled: Boolean,
    errorFeedback: String,
    maxlength: String,
    mask: String,
    validation: Function,
    codeMode: Boolean,
    externalIcon: String,
    internalIcon: String
  },
  methods: {
    setValue (event) {
      this.value = (this.mask ? maskJs(this.mask, event.target.value) : event.target.value) || ''
      this.valid = this.checkValid().isValid
      this.errorMessage = this.checkValid().errorMessage
      this.$emit('input', { name: this.inputName, value: this.value, touched: this.touched, valid: this.valid })
    },
    onBlur () {
      this.touched = true
      this.valid = this.checkValid().isValid
      this.errorMessage = this.checkValid().errorMessage
    },
    checkValid () {
      if (this.required && !this.value) return { isValid: false, errorMessage: 'Campo obrigatório' }
      else if (this.validation != null && !this.validation(this.value)) return { isValid: false, errorMessage: this.errorFeedback }
      else return { isValid: true, errorMessage: undefined }
    }
  }
}
</script>
